var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C8.38 2 9.63 2.56 10.54 3.46L8 6H14V0L11.95 2.05C10.68 0.78 8.93 0 7 0C3.47 0 0.57 2.61 0.0799999 6H2.1C2.56 3.72 4.58 2 7 2ZM12.64 11.14C13.3 10.24 13.76 9.17 13.92 8H11.9C11.44 10.28 9.42 12 7 12C5.62 12 4.37 11.44 3.46 10.54L6 8H0V14L2.05 11.95C3.32 13.22 5.07 14 7 14C8.55 14 9.98 13.49 11.14 12.64L16 17.49L17.49 16L12.64 11.14Z",
    fill: "#7F8090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindReplace);
export default __webpack_public_path__ + "static/media/Find_Replace.953c6e86.svg";
export { ForwardRef as ReactComponent };